export const UPDATE_CONFIG_LIST_LOADING = "UPDATE_CONFIG_LIST_LOADING"
export const UPDATE_CONFIG_LIST_PAGINATION = "UPDATE_CONFIG_LIST_PAGINATION"
export const UPDATE_FETCH_CONFIG_LIST_DATA = "UPDATE_FETCH_CONFIG_LIST_DATA"
export const UPDATE_FETCH_EDIT_CONFIG_API_DATA = "UPDATE_FETCH_EDIT_CONFIG_API_DATA"
export const CLEAR_EDIT_CONFIG_API_DATA = "CLEAR_EDIT_CONFIG_API_DATA"